<div class="download-modal-container" *ngIf='opened'>


    <div class="card" *ngIf="currentView === ModalView.FORMAT_SELECTION; else elseBlock">
        <div class="card-header d-flex align-items-center justify-content-center">
            <h4 style="margin-bottom: 0; margin-left:35%" >Descargar</h4>
            <button type="button" style="margin-left: 35%;" class="close" aria-label="Close" (click)="close()">
                <span aria-hidden="true" style="color: #A3ACBF;">&times;</span>
            </button>
        </div>

        <hr class="hr">

        <div class="card-body p-3">
            <div class="options">
                <div class="option">

                    <svg width="150" height="90" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" id="Icons_Document" overflow="hidden">
                        <path
                            d="M23 82 23 14 48 14 48 35 73 35 73 82 23 82ZM54 16.5 66.5 29 54 29 54 16.5ZM54 8 17 8 17 88 79 88 79 30 54 8Z"
                            stroke="#f2c63d" stroke-opacity="0%" stroke-width="1.33333" fill="#f2c63d" />
                        <rect x="29" y="45" width="38" height="4" stroke="#f2c63d" stroke-opacity="0%"
                            stroke-width="1.33333" fill="#f2c63d" />
                        <rect x="29" y="37" width="13" height="4" stroke="#f2c63d" stroke-opacity="0%"
                            stroke-width="1.33333" fill="#f2c63d" />
                        <rect x="29" y="53" width="38" height="4" stroke="#f2c63d" stroke-opacity="0%"
                            stroke-width="1.33333" fill="#f2c63d" />
                        <rect x="29" y="61" width="38" height="4" stroke="#f2c63d" stroke-opacity="0%"
                            stroke-width="1.33333" fill="#f2c63d" />
                        <rect x="29" y="69" width="38" height="4" stroke="#f2c63d" stroke-opacity="0%"
                            stroke-width="1.33333" fill="#f2c63d" />
                    </svg>

                    <div class="row" style="margin-top: 20px; justify-content: center;">
                        <span >PDF del estudio</span>
                    </div>

                    <div class="row">
                        <div class="col-12">

                            <button class="download_btn" (click)="downloadPDF()">
                                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.5 0V7.5H2.5L10 15L17.5 7.5H12.5V0H7.5ZM0 17.5V20H20V17.5H0Z"
                                        fill="#ffffff" />
                                </svg>
                            </button>

                        </div>
                    </div>
                    <!--<div class="row">
                        <div class="col-12">

                            <button class="download_btn" (click)="downloadPDFAndReport()">
                                <span >+ Informe</span>
                            </button>

                        </div>
                    </div>-->

                </div>

                <div class="option">

                    <svg fill="#f2c63d" width="150" height="90" viewBox="0 0 33 30" version="1.1"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M30 3.25h-28c-0.414 0-0.75 0.336-0.75 0.75v0 24c0 0.022 0.011 0.041 0.013 0.063 0.012 0.103 0.040 0.198 0.082 0.284l-0.002-0.005c0.050 0.087 0.11 0.162 0.181 0.225l0.001 0.001c0.017 0.015 0.027 0.035 0.046 0.048 0.015 0.010 0.033 0.006 0.048 0.015 0.107 0.071 0.238 0.115 0.378 0.119l0.001 0 0.002 0.001h28.001c0.414-0 0.75-0.336 0.75-0.75v0-24c-0-0.414-0.336-0.75-0.75-0.75v0zM29.25 4.75v14.771l-6.625-9.937c-0.144-0.191-0.37-0.313-0.625-0.313s-0.481 0.122-0.624 0.311l-0.001 0.002-7.545 11.318-4.361-3.488c-0.127-0.102-0.29-0.164-0.468-0.164-0.253 0-0.477 0.126-0.613 0.318l-0.002 0.002-5.636 8.051v-20.871zM3.44 27.25l5.716-8.164 4.375 3.5c0.121 0.104 0.28 0.167 0.454 0.167 0.046 0 0.091-0.004 0.135-0.013l-0.004 0.001c0.214-0.033 0.394-0.153 0.507-0.322l0.002-0.003 7.376-11.063 7.25 10.876v5.021zM8 12.75c1.519 0 2.75-1.231 2.75-2.75s-1.231-2.75-2.75-2.75c-1.519 0-2.75 1.231-2.75 2.75v0c0.002 1.518 1.232 2.748 2.75 2.75h0zM8 8.75c0.69 0 1.25 0.56 1.25 1.25s-0.56 1.25-1.25 1.25c-0.69 0-1.25-0.56-1.25-1.25v0c0.001-0.69 0.56-1.249 1.25-1.25h0z">
                        </path>
                    </svg>

                    <div class="row" style="margin-top: 20px; justify-content: center;">
                        <span >Imágenes JPG del estudio</span>
                    </div>

                    <div class="row">
                        <div class="col-12">

                            <button class="download_btn" (click)="downloadJPGS()">
                                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.5 0V7.5H2.5L10 15L17.5 7.5H12.5V0H7.5ZM0 17.5V20H20V17.5H0Z"
                                        fill="#ffffff" />
                                </svg>
                            </button>

                        </div>
                    </div>

                </div>

                <div class="option">

                    <svg width="150" height="90" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
                            stroke="#f2c63d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M11 13C12.1046 13 13 12.1046 13 11C13 9.89543 12.1046 9 11 9C9.89543 9 9 9.89543 9 11C9 12.1046 9.89543 13 11 13Z"
                            stroke="#f2c63d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>

                    <div class="row" style="margin-top: 20px; justify-content: center;">
                        <span > Imágenes DICOM del estudio</span>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <button class="download_btn" (click)="checkDownload()">
                                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.5 0V7.5H2.5L10 15L17.5 7.5H12.5V0H7.5ZM0 17.5V20H20V17.5H0Z"
                                        fill="#ffffff" />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <!--<div class="row" style="margin-top: 20px; justify-content: center;">
                        <input  type="checkbox" [(ngModel)]="downloadSameZip" (change)="downloadSameZip != downloadSameZip"> Descarga en bloque
                    </div>-->

                </div>

            </div>
        </div>

    </div>

    <ng-template #elseBlock>

        <div class="card">
            <div class="card-header d-flex align-items-center justify-content-center">
                <h4 style="margin-bottom: 0; margin-left:35%" >Descargar</h4>
                <button type="button" style="margin-left: 35%;" class="close" aria-label="Close" (click)="closeSecondDownloadModal()">
                    <span aria-hidden="true" style="color: #A3ACBF;">&times;</span>
                </button>
            </div>

            <hr class="hr">

            <div class="card-body p-3">
                <div class="options">
                    <div class="option_secondModal">
                        <div class="row">
                            <p >Se procederá a la descarga de las imágenes completas del estudio en formato de diagnóstico</p>
                            <p >Modifica alguno de los siguiente campos si fuese necesario antes de descargar</p>
                        </div>

                        <!-- Inputs para campos modificables -->
                        <div class="row mb-3">
                            <div class="col-md-4">
                                <label  for="patientName" class="form-label">Nombre del paciente</label>
                                <input type="text" class="form-control" id="patientName" 
                                       [(ngModel)]="patientName" placeholder="Nombre del paciente">
                            </div>
                            <div class="col-md-4">
                                <label  for="patientId" class="form-label">Id del paciente</label>
                                <input type="text" class="form-control" id="patientId" [(ngModel)]="patientId" placeholder="Id del paciente">
                            </div>
                            <div class="col-md-4">
                                <label  for="accessionNumber" class="form-label">Accesion Number</label>
                                <input type="text" class="form-control" id="accessionNumber" 
                                       [(ngModel)]="accessionNumber" placeholder="Accesion Number">
                            </div>
                        </div>

                        <!-- Opción de anonimizar -->
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="anonymizeCheck" 
                                           [(ngModel)]="anonymize">
                                    <label class="form-check-label" for="anonymizeCheck">
                                        <strong  >Anonimizar estudio</strong>
                                        <br>
                                        <small class="text-muted" >Si desea anonimizar el estudio marque esta opción antes de descargar</small>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="btn_row">
                            <button  class="btn_secondModal" (click)="closeSecondDownloadModal()">Cancelar</button>
                            <button  class="btn_secondModal" (click)="downloadDCMS()">Descargar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

  </ng-template>


</div>